import { InfiniteListActions, SimpleListActions } from 'mc/lib/list';
import { utils } from 'mc/lib';
import LogovaniApiApi from '../api/gen/pohledavky/LogovaniApiApi';
import * as StavVolani from '../api/gen/pohledavky/StavVolani';

export const CALL_LOG_LIST_AREA = 'callLogList';
export const CALL_LOG_SLUZBA_LIST_AREA = 'callLogSluzbaList';

export const NEROZHODUJE_VALUE = 'nerozhoduje';

/**
 * Načtení ID logů na základě filtru
 *
 * @param parent
 * @param filter filtr
 * @returns {Promise<number[]>}
 */
const getLogyAllIds = (parent, filter) => {
    filter = {
        datumCasVolaniOd: utils.commons.dateTimeToLocalUTC(filter.datumCasVolaniOd),
        datumCasVolaniDo: utils.commons.dateTimeToLocalUTC(filter.datumCasVolaniDo),
        sluzba: filter.sluzba !== NEROZHODUJE_VALUE ? filter.sluzba : undefined,
        stav: StavVolani.values.includes(filter.stav) ? filter.stav : undefined,
        parametryVstup: filter.parametryVstup,
        parametryVystup: filter.parametryVystup,
        popisChyby: filter.popisChyby,
    };
    return LogovaniApiApi.findIdsByFilter(filter);
};

/**
 * Načtení logů dle ID.
 *
 * @param ids množina ID logů
 */
const getLogyByIds = (ids) => {
    return LogovaniApiApi.findByIds(ids);
};

/**
 * Načtení seznamu logů.
 *
 * @param force
 */
export function fetchLogyIfNeeded(force = false) {
    return InfiniteListActions.fetchIfNeeded(CALL_LOG_LIST_AREA, undefined, getLogyAllIds, getLogyByIds, force);
}

/**
 * Filtrování logů.
 *
 * @param filter filtr
 */
export function filterLogy(filter = {}) {
    return InfiniteListActions.filter(CALL_LOG_LIST_AREA, filter);
}

/**
 * Donačtení dalších logů.
 *
 * @returns {void|{type: string, area: *}|*}
 */
export function loadMoreLogy() {
    return InfiniteListActions.loadMore(CALL_LOG_LIST_AREA, getLogyByIds);
}

/**
 * Přenačtení seznamu logů.
 * @returns {Function|void}
 */
export function reloadLogy() {
    return InfiniteListActions.reload(CALL_LOG_LIST_AREA, undefined, getLogyAllIds, getLogyByIds);
}

/**
 * Načtení seznamu hodnot služeb.
 * @returns {Function}
 */
export function fetchSluzbyListIfNeeded() {
    return (dispatch) => {
        dispatch(SimpleListActions.fetchIfNeeded(CALL_LOG_SLUZBA_LIST_AREA, undefined, () => {
            return LogovaniApiApi.getLogSluzby();
        }));
    };
}

/**
 * Zneplatnění seznamu hodnot služeb.
 * @returns {Function}
 */
export function invalidateSluzbyList() {
    return (dispatch) => {
        dispatch(SimpleListActions.invalidate(CALL_LOG_SLUZBA_LIST_AREA));
    };
}
